import { Component } from '@angular/core';
import { FollowButton, HomeCard, HomeCardComponentType, HomeCardIcon, HomeCardLink } from '@tytapp/app/pages/home-page/home-cards.service';

@Component({
    selector: 'tyt-discord-home-card',
    templateUrl: './discord-card.component.html',
    styleUrls: ['./discord-card.component.scss']
})
export class DiscordCardComponent implements HomeCardComponentType {
    card: HomeCard;
    title?: string;
    icon?: HomeCardIcon;
    more?: HomeCardLink;
    followButton?: FollowButton;

    hidden?: boolean;
    classes?: string[];
    fullBleed?: boolean;
}